import type * as lazyIndex from "./lazyIndex";
import { LazyModule } from "owa-bundling";

type AddRecipientsDialogModule = {
    AddRecipientsDialog: typeof lazyIndex.AddRecipientsDialog;
    setShouldShowAddRecipientsDialogMutator: typeof lazyIndex.setShouldShowAddRecipientsDialogMutator;
    AddressBook: typeof lazyIndex.AddressBook;
    showAddressBookMutator: typeof lazyIndex.showAddressBookMutator;
    TransitionState: typeof lazyIndex.TransitionState;
};

export const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<AddRecipientsDialogModule>(() => import(/* webpackChunkName: "" */ "./lazyIndex"), {
    name: "AddRecipientsDialog",
});
